import { render } from "./BaseText.vue?vue&type=template&id=212b5854&scoped=true&ts=true"
import script from "./BaseText.vue?vue&type=script&lang=ts"
export * from "./BaseText.vue?vue&type=script&lang=ts"

import "./BaseText.vue?vue&type=style&index=0&id=212b5854&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-212b5854"]])

export default __exports__